import { isNil } from 'lodash-es'
import { useTranslations } from 'next-intl'

import { Card } from '@/entities/contract'
import { formatPhoneNumber } from '@/shared/lib'
import { Description } from '@/shared/ui'

import { ChatButton } from './chat-button'

export type Props = {
  guestName: string
  guestPhoneNumber: string
  guestChatRoomUrl: string | null
}

export const GuestInformation = ({
  guestName,
  guestPhoneNumber,
  guestChatRoomUrl,
}: Props) => {
  const t = useTranslations('lease_detail.information')

  const showChatButton = !isNil(guestChatRoomUrl)

  return (
    <Card.Item>
      <Card.ItemTitle>{t('tenant')}</Card.ItemTitle>
      <Card.ItemContent className="space-y-6">
        <Description.List>
          <Description.Item label={t('label.name')} value={guestName} />
          <Description.Item
            label={t('label.contact')}
            value={formatPhoneNumber(guestPhoneNumber)}
          />
        </Description.List>
        {showChatButton && <ChatButton chatRoomUrl={guestChatRoomUrl} />}
      </Card.ItemContent>
    </Card.Item>
  )
}
